import React from 'react';

import DataTable from '@components/DataTable';
import LazyImgixImage from '@components/LazyImgixImage';
import { AppContextProvider, Env } from '@contexts/AppContext';
import { ProjectColumnConfigFn, ProjectData } from '@interfaces/projects';
import { getImgixSrc } from '@utils/images';

interface TeslaDiasporaDatabaseProps<TData, TValue> {
  data: ProjectData<TData, TValue>;
  env: Env;
  isWebview: boolean;
  projectId: number;
}

const PROJECT_IMAGE_PATH = 'projects/tesla-diaspora';
const COLUMN_IMAGE = 'image';

const columnConfigFn: ProjectColumnConfigFn = (column) => {
  if (column.id === COLUMN_IMAGE) {
    return {
      ...column,
      cell: (cell) => (
        <LazyImgixImage
          alt={cell.getValue() as string}
          className="h-40 w-40 rounded-full"
          src={getImgixSrc({
            path: `${PROJECT_IMAGE_PATH}/${cell.getValue()}`,
            isEnvDependent: false,
          })}
        />
      ),
    };
  } else return column;
};

const TeslaDiasporaDatabase = <TData, TValue>({
  data,
  env,
  isWebview,
  projectId,
}: TeslaDiasporaDatabaseProps<TData, TValue>): JSX.Element => {
  const pinnedCols = data.columns.slice(0, 2).map((col) => col.id);

  return (
    <AppContextProvider env={env} isWebview={isWebview}>
      <DataTable
        classNameThead="h-[70px]"
        columns={data.columns}
        columnConfigFn={columnConfigFn}
        data={data.data}
        hiddenCols={data.hiddenCols}
        pinnedCols={pinnedCols}
        projectId={projectId}
        sortCols={data.sortCols}
        showSearch
      />
    </AppContextProvider>
  );
};

export default TeslaDiasporaDatabase;
